import React from 'react';
import { Button } from 'fw/components'
import PropTypes from 'prop-types';

class SaveCancel extends React.Component {
    render() {
        return (
            <div className="text-right">
                <Button id="btnCancel" bsStyle="link" onClick={this.props.onCancel}>Cancel</Button>
                <Button id="btnSave" bsStyle="primary" type="submit" disabled={this.props.disabled}>Save Changes</Button>
            </div>);
    }
}

SaveCancel.propTypes = {
    onCancel: PropTypes.func.isRequired
  };
  

export default SaveCancel;




// WEBPACK FOOTER //
// ./src/fw/components/saveCancel/SaveCancel.js